import * as React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Backdrop,
  CircularProgress,
  IconButton,
  Tooltip,
  Box,
  Pagination,
  FormControl,
  MenuItem,
  Checkbox,
  InputLabel,
  Select,
  TableSortLabel,
  Toolbar,
  Typography,
  SelectChangeEvent,
  Stack,
} from '@mui/material';
import HttpService from '../../../hooks/Https-services';
import {
  API_ROUTES,
  dateFormat,
  PRIORITY,
  timeFormat,
} from '../../../utils/constant';
import { useBoolean } from '../../../hooks/use-boolean';
import usePopover from '../../../hooks/use-popover';
import { StatusDialog } from '../../../components/custom-dialog';
import Iconify from '../../../components/iconify';
import { toast } from 'react-toastify';
import { visuallyHidden } from '@mui/utils';
import { alpha } from '@mui/material/styles';
import { LoadingButton } from '@mui/lab';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import dayjs from 'dayjs';
import { useParams } from 'react-router';
import moment from 'moment';

interface Game {
  name: string;
  email: any;
  role: any;
  team: string;
  shift: any;
  // Add other relevant fields here
}
function AssignGame() {
  const [tableData, setTableData] = React.useState<any[]>([]);
  const [loading, setLoading] = React.useState(false);
  const assginModerator = useBoolean();
  const popover = usePopover();
  const [currentPage, setCurrentPage] = React.useState(1);
  const [totalPages, setTotalPages] = React.useState(10);
  const [totalCount, setTotalCount] = React.useState(0);
  const itemsPerPage = 10;
  const { id } = useParams();
  const [orderBy, setOrderBy] = React.useState<any>(null);
  const [order, setOrder] = React.useState<any>(null);
  const [selected, setSelected] = React.useState<readonly number[]>([]);
  const [activeModerator, setActiveMaoderator] = React.useState<any[]>([]);
  const [moderatorData, setModeratorData] = React.useState<any>('');

  const handleModeratorChange = (
    event: SelectChangeEvent<typeof moderatorData>
  ) => {
    const {
      target: { value },
    } = event;
    setModeratorData(value);
  };

  const fetchActiveModeratorList = React.useCallback(async () => {
    try {
      setLoading(true);
      const query: any = {
        requestId: Number(id),
      };
      const response = await HttpService.get(
        API_ROUTES.activeModeratorList +
          `?${new URLSearchParams(query).toString()}`
      );
      setActiveMaoderator(response.data.data || []);
    } catch (error: any) {
      console.error('Error fetching shift list:', error);
    } finally {
      setLoading(false);
    }
  }, []);

  const handlePageChange = (
    event: React.ChangeEvent<unknown>,
    page: number
  ) => {
    setCurrentPage(page); // Update the current page
  };

  const fetchTableList = React.useCallback(async () => {
    try {
      setLoading(true);
      const query: any = {
        page: currentPage,
        limit: itemsPerPage,
      };

      const response = await HttpService.get(
        API_ROUTES.assignGameList +
          `/${id}` +
          `?${new URLSearchParams(query).toString()}`
      );
      setTableData(response.data.data.list || []);
      setTotalPages(response.data.data.totalPages);
      setTotalCount(response.data.data.totalCount);
    } catch (error: any) {
      console.error('Error fetching user list:', error);
    } finally {
      setLoading(false);
    }
  }, [currentPage, itemsPerPage, order]);

  React.useEffect(() => {
    fetchTableList();
  }, [fetchTableList]);

  const createSortHandler = (property: keyof Game) => () => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      const newSelected = [...selected, ...tableData.map((n) => n.gameId)];
      const uniqueSelected = Array.from(new Set(newSelected)); // Ensure no duplicates
      setSelected(uniqueSelected);
      return;
    }
    setSelected([]);
  };
  const handleClick = (event: React.MouseEvent<unknown>, gameId: number) => {
    const selectedIndex = selected.indexOf(gameId);
    let newSelected: readonly number[] = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, gameId);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    setSelected(newSelected);
  };

  interface EnhancedTableProps {
    numSelected: number;
    onSelectAllClick: (event: React.ChangeEvent<HTMLInputElement>) => void;
    rowCount: number;
  }

  function EnhancedTableHead(props: EnhancedTableProps) {
    const { onSelectAllClick, numSelected, rowCount } = props;

    return (
      <TableHead>
        <TableRow>
          <TableCell padding="checkbox">
            <Checkbox
              color="primary"
              indeterminate={numSelected > 0 && numSelected < rowCount}
              checked={rowCount > 0 && numSelected === rowCount}
              onChange={onSelectAllClick}
              inputProps={{
                'aria-label': 'select all desserts',
              }}
            />
          </TableCell>
          <TableCell align="left">Game Id</TableCell>
          <TableCell align="left">Priority</TableCell>
          <TableCell align="left">Date</TableCell>
          <TableCell align="left">Teams</TableCell>
          <TableCell align="left">Status</TableCell>
        </TableRow>
      </TableHead>
    );
  }
  const [loadingShift, setLodingShift] = React.useState(false);
  const assginToModerator = async () => {
    setLodingShift(true);
    const data = {
      assignId: moderatorData,
      gameIds: selected,
      requestId: Number(id),
    };
    try {
      const res = await HttpService.post(
        API_ROUTES.assignGameToModerator,
        data
      );
      fetchTableList();
      toast.success(res.data.message, {
        position: 'bottom-right',
      });
      assginModerator.onFalse();
      setSelected([]);
      setModeratorData('');
      setLodingShift(false);
    } catch (error) {
      console.log('Error during Clock In:', error);
      setLodingShift(false);
    }
  };

  interface EnhancedTableToolbarProps {
    numSelected: number;
  }

  function EnhancedTableToolbar(props: EnhancedTableToolbarProps) {
    const { numSelected } = props;
    return (
      <Toolbar
        sx={[
          {
            pl: { sm: 2 },
            pr: { xs: 1, sm: 1 },
          },
          numSelected > 0 && {
            bgcolor: (theme) =>
              alpha(
                theme.palette.primary.main,
                theme.palette.action.activatedOpacity
              ),
          },
        ]}
      >
        {numSelected > 0 && (
          <Typography
            sx={{ flex: '1 1 100%' }}
            color="inherit"
            variant="subtitle1"
            component="div"
          >
            {numSelected} selected
          </Typography>
        )}
        {numSelected > 0 && (
          <Tooltip title="Assgin Moderator">
            <IconButton
              onClick={() => {
                fetchActiveModeratorList();
                assginModerator.onTrue();
                popover.onClose();
              }}
            >
              <Iconify icon="fluent:shifts-add-24-filled" width={25} />
            </IconButton>
          </Tooltip>
        )}
      </Toolbar>
    );
  }

  return (
    <>
      <Box sx={{ display: 'block' }}></Box>
      <EnhancedTableToolbar numSelected={selected.length} />
      <TableContainer component={Paper}>
        <Table aria-label="collapsible table">
          <EnhancedTableHead
            numSelected={selected.length}
            onSelectAllClick={handleSelectAllClick}
            rowCount={totalCount}
          />
          <TableBody>
            {(tableData || []).map((row: any, index: any) => {
              const isItemSelected = selected.includes(row.gameId);
              const labelId = `enhanced-table-checkbox-${index}`;

              return (
                <TableRow
                  hover
                  // onClick={(event) => handleClick(event, row.id)}
                  role="checkbox"
                  aria-checked={isItemSelected}
                  tabIndex={-1}
                  key={row.id}
                  selected={isItemSelected}
                  sx={{ cursor: 'pointer' }}
                >
                  <TableCell padding="checkbox">
                    <Checkbox
                      color="primary"
                      onClick={(event) => handleClick(event, row.gameId)}
                      checked={isItemSelected}
                      inputProps={{
                        'aria-labelledby': labelId,
                      }}
                    />
                  </TableCell>
                  <TableCell
                    sx={{ '&:hover': { color: 'orange', cursor: 'pointer' } }}
                  >
                    {row.gameId}
                    <Tooltip title="Copy Game ID">
                      <IconButton
                        onClick={() => {
                          navigator.clipboard.writeText(row.gameId);
                        }}
                        size="small"
                        sx={{ marginLeft: 1 }} // Add margin for spacing
                      >
                        <ContentCopyIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  </TableCell>
                  <TableCell>
                    <Box
                      sx={{
                        background:
                          {
                            MINOR: '#eeeeee',
                            NORMAL: '#dbf2ff',
                            MAJOR: '#eb6f33',
                            CRITICAL: '#d30584',
                            SHOW_STOPPER: '#e30000',
                          }[PRIORITY[row?.game?.priority]] || '#ffffff', // Default to white if no match
                        color: '#000',
                        height: '40px',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        padding: '0 10px',
                        borderRadius: 3,
                        fontWeight: 600,
                      }}
                    >
                      {PRIORITY?.[row?.game?.priority]}
                    </Box>
                  </TableCell>
                  <TableCell>
                    {row?.game?.createdAt ? (
                      <Stack direction={'column'}>
                        <Typography variant="body2">
                          {moment(row?.game?.createdAt).format(`${dateFormat}`)}
                        </Typography>
                        <Typography variant="body2">
                          {moment(row?.game?.createdAt).format(`${timeFormat}`)}
                        </Typography>
                      </Stack>
                    ) : (
                      '-'
                    )}
                  </TableCell>
                  <TableCell>
                    <div>
                      <span>{row?.game?.game?.homeTeam?.nameEn}</span>
                      <br />
                      <span>{row?.game?.game?.awayTeam?.nameEn}</span>
                    </div>
                  </TableCell>
                  <TableCell sx={{ padding: '0px', paddingLeft: '7px' }}>
                    {row?.game?.gameStatusTms}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Pagination Component */}
      <Box display="flex" justifyContent="center" my={2}>
        <Pagination
          count={totalPages} // Total number of pages
          page={currentPage} // Current page
          onChange={handlePageChange} // Handle page change
          color="primary"
        />
      </Box>
      <StatusDialog
        open={assginModerator.value}
        onClose={assginModerator.onFalse}
        fullWidth={true}
        title="Assgin Moderator"
        content={
          <>
            {' '}
            <FormControl sx={{ flexShrink: 0, marginTop: 2 }} fullWidth>
              <InputLabel>Assign Moderator</InputLabel>
              <Select
                label="Select Moderator"
                value={moderatorData}
                onChange={handleModeratorChange}
                MenuProps={{ PaperProps: { sx: { maxHeight: 240 } } }}
              >
                {activeModerator && activeModerator.length > 0 ? (
                  activeModerator.map((activeModerator: any) => (
                    <MenuItem
                      key={activeModerator.id}
                      value={activeModerator.id}
                    >
                      <span style={{ fontWeight: 'bolder' }}>
                        {activeModerator.name}
                      </span>{' '}
                      &nbsp; &nbsp; In_Progress :{' '}
                      {activeModerator?.inProgressCount}
                      &nbsp; &nbsp; In_QC : {activeModerator?.inQcCount}
                      &nbsp; &nbsp; Created : {activeModerator?.createdCount}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem disabled>No Moderator Found</MenuItem>
                )}
              </Select>
            </FormControl>
          </>
        }
        action={
          <LoadingButton
            variant="contained"
            color="success"
            loading={loadingShift}
            onClick={() => {
              assginToModerator();
              // comment.onFalse();
            }}
          >
            Assgin Moderator
          </LoadingButton>
        }
      />

      {/* Backdrop with CircularProgress for loader */}
      <Backdrop
        sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
}

export default AssignGame;
